import { useMainStore } from '@/store/index'

/** cssVars值的基础类 */
export abstract class _BaseCssVarValue {
  /** css的类型 */
  abstract cssType: string
  /** 初始化构造函数 */
  constructor() {
    const { isWeb } = useMainStore()
    if (isWeb) {
      this.initPC()
    } else {
      this.initH5()
    }
  }
  /** 初始化PC */
  protected abstract initPC(): this
  /** 初始化H5 */
  protected abstract initH5(): this
}
